import { createSelector } from 'reselect';
import { MAX_ITEMS_DASHBOARD } from '../../dashboard/constants';
import {
    transformPropertiesDataForDashboard,
    transformReservationsDataForDashboard,
    transformUsersDataForDashboard,
} from './transforms';

export const areDashboardUsersLoading = (state) =>
    state.dashboard.users.loading;
export const areDashboardPropertiesLoading = (state) =>
    state.dashboard.properties.loading;
export const areDashboardReservationsLoading = (state) =>
    state.dashboard.reservations.loading;

export const isDashboardNewUsersCountLoading = (state) =>
    state.dashboard.newUsers.loading;
export const isDashboardNewPropertiesCountLoading = (state) =>
    state.dashboard.newProperties.loading;
export const isDashboardNewReservationsCountLoading = (state) =>
    state.dashboard.newReservations.loading;

export const getUsersForDashboard = createSelector(
    (state) => state.dashboard.users.data,
    (users) =>
        transformUsersDataForDashboard(users.slice(0, MAX_ITEMS_DASHBOARD)),
);
export const getPropertiesForDashboard = createSelector(
    (state) => state.dashboard.properties.data,
    (properties) =>
        transformPropertiesDataForDashboard(
            properties.slice(0, MAX_ITEMS_DASHBOARD),
        ),
);
export const getReservationsForDashboard = createSelector(
    (state) => state.dashboard.reservations.data,
    (reservations) =>
        transformReservationsDataForDashboard(
            reservations.slice(0, MAX_ITEMS_DASHBOARD),
        ),
);

export const getNewUsersCountForDashboard = (state) =>
    state.dashboard.newUsers.count;
export const getNewPropertiesCountForDashboard = (state) =>
    state.dashboard.newProperties.count;
export const getNewReservationsCountForDashboard = (state) =>
    state.dashboard.newReservations.count;

export const getUsersTotalForDashboard = (state) => state.dashboard.users.total;
export const getPropertiesTotalForDashboard = (state) =>
    state.dashboard.properties.total;
export const getReservationsTotalForDashboard = (state) =>
    state.dashboard.reservations.total;

// Get the raw properties list (untransformed)
export const getOwnersProperties = (state) =>
    state.dashboard.ownerDashboard?.properties || [];

// Get total reservations for all properties (sum of reservations.total, or adjust as needed)
export const getOwnerReservationTotals = (state) => {
    return state.dashboard.ownerDashboard?.reservations?.totals || [];
};

export const getOwnerReservations = (state) =>
    state.dashboard.ownerDashboard?.reservations || {};

// Get Stripe data (assumes state.dashboard.stripeData exists)
export const getOwnerStripeData = (state) =>
    state.dashboard?.ownerDashboard?.stripeData || null;

// Get property by propertyId
export const getOwnerPropertyById = (propertyId) => (state) => {
    const properties = state.dashboard.ownerDashboard?.properties || [];
    return properties.find((p) => p.id === propertyId);
};

// Get reservations by propertyId (assumes reservation objects have propertyId)
export const getOwnerReservationsByPropertyId = (propertyId) => (state) => {
    const reservations =
        state.dashboard.ownerDashboard?.reservations?.properties || {};
    return reservations[propertyId] || null;
};

// Get Stripe data by propertyId (assumes stripeData is an object keyed by propertyId)
export const getOwnerStripeDataByPropertyId = (propertyId) => (state) => {
    const stripeData =
        state.dashboard.ownerDashboard?.stripeData?.properties || {};
    return stripeData[propertyId] || null;
};

export const getOwnerDashboardLoading = (state) =>
    state.dashboard.ownerDashboard.loading;

// Get selected property ID from ownerDashboard state
export const getOwnerSelectedPropertyId = (state) =>
    state.dashboard.ownerDashboard.selectedPropertyId;

// New selectors for startDate and endDate
export const getOwnerDashboardStartDate = (state) =>
    state.dashboard.ownerDashboard.startDate;
export const getOwnerDashboardEndDate = (state) =>
    state.dashboard.ownerDashboard.endDate;

export const getOwnerDashboardError = (state) =>
    state.dashboard.ownerDashboard.error || null;
